import { render, staticRenderFns } from "./ColumnsLayout.vue?vue&type=template&id=9d30992a&scoped=true&functional=true&"
import script from "./ColumnsLayout.vue?vue&type=script&lang=js&"
export * from "./ColumnsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsLayout.vue?vue&type=style&index=0&id=9d30992a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "9d30992a",
  null
  
)

export default component.exports